<header [ngClass]="{fullscreen: fullScreenHeader}"
        class="cover">
  <div class="scroll-indicator br-16"
       matTooltip="Scrollujte nižšie pre obsah stránky"
       matTooltipPosition="above">
    <div class="scroll-indicator__dot br-16"></div>
  </div>
</header>
